module.exports = __webpack_public_path__ + "8655a8078d17f3f7878baafc67d49895.jpg";